import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Sep 06 2018
 * @author SKu
 */
import * as React from 'react';
import { SelectValidated } from '../../../../inputs/Select';
import CellEditor from './CellEditor';
export var ReleaseItemPriceCodeEditor =
/*#__PURE__*/
function (_CellEditor) {
  _inherits(ReleaseItemPriceCodeEditor, _CellEditor);

  function ReleaseItemPriceCodeEditor(props) {
    var _this;

    _classCallCheck(this, ReleaseItemPriceCodeEditor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseItemPriceCodeEditor).call(this, props));
    /**
     * Handles changes of the select element
     */

    _this.onChange = function (value) {
      _this.updateValue(value);
    };

    _this.render = function () {
      return React.createElement("div", {
        ref: _this.wrapper
      }, React.createElement(SelectValidated, {
        options: _this.colDef.selectOptions,
        value: _this.state.value,
        onChange: _this.onChange,
        tiny: true,
        validationError: _this.state.validationError
      }));
    };

    return _this;
  }

  _createClass(ReleaseItemPriceCodeEditor, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // Stops editing if the value is selected
      if (this.state.value !== prevState.value && !this.props.context.store.invalid && !this.state.validationError) {
        this.props.stopEditing();
      }
    }
  }]);

  return ReleaseItemPriceCodeEditor;
}(CellEditor);